document.addEventListener("DOMContentLoaded", () => {
    const regulation = document.querySelector("#register-regulation_accept");
    const register_policy_input = document.querySelector("#register-privacy_policy");
    if(regulation && register_policy_input){
        regulation.addEventListener("change", ()=> {
            if(regulation.checked && register_policy_input.checked){
                document.querySelector(".login__main .btn_register").disabled = false;
            }else {
                document.querySelector(".login__main .btn_register").disabled = true;
            }
        })
        register_policy_input.addEventListener("change", ()=> {
            if(register_policy_input.checked && regulation.checked){
                document.querySelector(".login__main .btn_register").disabled = false;
            }else {
                document.querySelector(".login__main .btn_register").disabled = true;
            }
        })
    }
    const contact_input = document.querySelector("#contact-accept-input");
    if(contact_input){
        contact_input.addEventListener("change", () => {
            if(contact_input.checked){
                document.querySelector(".contact-form__button-wrapper .custom-contact-btn").disabled = false;
            }else {
                document.querySelector(".contact-form__button-wrapper .custom-contact-btn").disabled = true;
            }
        })
    }

    var popup_interval;
    popup_interval = setInterval(function popup_find(){
        if(document.querySelector(".qsk-popup__box-form .qsk-popup__field-action")) {
            clearInterval(popup_interval);//btn_disable
            document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = true;
            document.querySelector(".qsk-popup__box-form .qsk-popup__form").style.marginBottom = "0px";
            document.querySelector(".qsk-popup__body .qsk-popup__body-box .qsk-popup__box-content").style.marginTop = "40px";
            var embedHTML = 
            `<div class="popup_confirm_accept">
                <input type="checkbox" name="privacy_policy"
                    aria-required="true" id="popup_privacy_policy"
                />
                <label for="popup_privacy_policy">Potwierdzam, że zapoznałem się z <a href="https://pl.starhouselove.com/policies/privacy-policy">polityką prywatności</a> sklepu 
                    internetowego.
                </label>
            </div>
            <div class="popup_confirm_accept">
                <input type="checkbox" name="accept_personal"
                    aria-required="true" id="popup_accept_personal"
                />
                <label for="popup_accept_personal">
                    <div class="personal_description">
                        Zgadzam się na przetwarzanie moich danych osobowych (adres email) 
                        przez Sprzedawcę (SHG Sp. z o.o., ul. T. Kościuszki 130C/31, 50-439 
                        Wrocław) w celu marketingowym. Wyrażenie zgody jest dobrowolne. Mam 
                        prawo cofnięcia zgody w dowolnym momencie bez wpływu na zgodność z 
                        prawem przetwarzania, którego dokonano na podstawie zgody przed jej 
                        cofnięciem. Mam prawo dostępu do treści swoich danych i ich sprostowania, 
                        usunięcia, ograniczenia przetwarzania, oraz prawo do przenoszenia danych 
                        na zasadach zawartych w <a href="https://pl.starhouselove.com/policies/privacy-policy">polityką prywatności</a> sklepu internetowego. Dane osobowe w sklepie 
                        internetowym przetwarzane są zgodnie z <a href="https://pl.starhouselove.com/policies/privacy-policy">polityką prywatności</a>. Zachęcamy do zapoznania się z 
                        polityką przed wyrażeniem zgody.
                    </div>
                    <input type="checkbox" id="popup-accept-view-more">
                    <label for="popup-accept-view-more">
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.3348 14L9.69727 8.36246L11.3077 6.75208L18.5555 14L11.3077 21.2479L9.69727 19.6375L15.3348 14Z" fill="#272850"></path>
                        </svg>
                    </label>
                </label>
                
            </div>
            `;
            var create_ele = document.createElement('div');
            create_ele.className = "custom_popup_fields";
            create_ele.innerHTML = embedHTML;
            document.querySelector(".qsk-popup__box-form .qsk-popup__form").appendChild(create_ele);
        }
        const popup_privacy_policy = document.querySelector("#popup_privacy_policy");
        const popup_accept_personal = document.querySelector("#popup_accept_personal");
        if(popup_privacy_policy && popup_accept_personal){
            popup_privacy_policy.addEventListener("change", () => {
                if(popup_privacy_policy.checked && popup_accept_personal.checked){
                    document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = false;
                }else {
                    document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = true;
                }
            });
            popup_accept_personal.addEventListener("change", () => {
                if(popup_privacy_policy.checked && popup_accept_personal.checked){
                    document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = false;
                }else {
                    document.querySelector(".qsk-popup__box-form .qsk-popup__field-action .qsk-popup__field-button").disabled = true;
                }
            })
        }
    }, 1000);
    
  })

function initQuickCartValidation() {
    const checkoutButton = document.querySelector(".quick-cart__submit");
    if (!checkoutButton) return;
    
    if (checkoutButton.dataset.validationInitialized === 'true') return;
    checkoutButton.dataset.validationInitialized = 'true';
    
    const regulationAccept = document.querySelector("#regulation_accept");
    const privacyPolicy = document.querySelector("#privacy_policy");

    if (regulationAccept && !regulationAccept.dataset.listenerAdded) {
        regulationAccept.dataset.listenerAdded = 'true';
        regulationAccept.addEventListener("change", () => {
            if (regulationAccept.checked) {
                const regulationParent = regulationAccept.closest(".confirm_accept");
                if (regulationParent) {
                    regulationParent.classList.remove("warning");
                }
            }
        });
    }

    if (privacyPolicy && !privacyPolicy.dataset.listenerAdded) {
        privacyPolicy.dataset.listenerAdded = 'true';
        privacyPolicy.addEventListener("change", () => {
            if (privacyPolicy.checked) {
                const privacyParent = privacyPolicy.closest(".confirm_accept");
                if (privacyParent) {
                    privacyParent.classList.remove("warning");
                }
            }
        });
    }

    checkoutButton.addEventListener("click", (e) => {
        const regulationParent = regulationAccept.closest(".confirm_accept");
        const privacyParent = privacyPolicy.closest(".confirm_accept");

        const allConfirmAcceptElements = document.querySelectorAll(".confirm_accept");
        allConfirmAcceptElements.forEach(element => {
            element.classList.remove("warning");
        });
        removeExistingTooltip();

        if (!regulationAccept || !privacyPolicy) {
            return;
        }
        if (!regulationAccept.checked || !privacyPolicy.checked) {
            e.preventDefault();
            e.stopPropagation();
            if (!regulationAccept.checked) {
                if (regulationParent) {
                    regulationParent.classList.add("warning");
                }
            }
            if (!privacyPolicy.checked) {
                if (privacyParent) {
                    privacyParent.classList.add("warning");
                }
            }
            showTooltip(checkoutButton, "Proszę zaakceptować warunki");
            return false;
        }
        window.location.href = '/checkout';
        return true;
    });
}

function showTooltip(element, message) {
    removeExistingTooltip();
    element.style.position = "relative";

    const tooltip = document.createElement("div");
    tooltip.className = "checkout-validation-tooltip";
    tooltip.textContent = message;
    tooltip.style.cssText = `
        position: absolute;
        bottom: calc(100% + 10px);
        left: 50%;
        transform: translateX(-50%);
        background: #dc3545;
        color: white;
        padding: 10px 15px;
        border-radius: 6px;
        font-size: 14px;
        white-space: nowrap;
        z-index: 9999;
        box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.2s ease;
    `;

    const arrow = document.createElement("div");
    arrow.style.cssText = `
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-top: 8px solid #dc3545;
    `;
    tooltip.appendChild(arrow);

    element.appendChild(tooltip);

    setTimeout(() => {
        tooltip.style.opacity = "1";
    }, 10);

    setTimeout(() => {
        removeExistingTooltip();
    }, 4000);
}

function removeExistingTooltip() {
    const existingTooltip = document.querySelector(".checkout-validation-tooltip");
    if (existingTooltip) {
        existingTooltip.remove();
    }
}

function initMainCartValidation() {
    const checkoutButton = document.querySelector(".cart__submit");
    if (!checkoutButton) return;

    const regulationAccept = document.querySelector("#main_regulation_accept");
    const privacyPolicy = document.querySelector("#main_privacy_policy");

    if (regulationAccept) {
        regulationAccept.addEventListener("change", () => {
            if (regulationAccept.checked) {
                const regulationParent = regulationAccept.closest(".confirm_accept");
                if (regulationParent) {
                    regulationParent.classList.remove("warning");
                }
            }
        });
    }

    if (privacyPolicy) {
        privacyPolicy.addEventListener("change", () => {
            if (privacyPolicy.checked) {
                const privacyParent = privacyPolicy.closest(".confirm_accept");
                if (privacyParent) {
                    privacyParent.classList.remove("warning");
                }
            }
        });
    }

    checkoutButton.addEventListener("click", (e) => {
        const allConfirmAcceptElements = document.querySelectorAll(".confirm_accept");
        allConfirmAcceptElements.forEach(element => {
            element.classList.remove("warning");
        });
        removeExistingTooltip();

        if (!regulationAccept || !privacyPolicy) {
            return;
        }

        if (!regulationAccept.checked || !privacyPolicy.checked) {
            e.preventDefault();
            e.stopPropagation();

            if (!regulationAccept.checked) {
                const regulationParent = regulationAccept.closest(".confirm_accept");
                if (regulationParent) {
                    regulationParent.classList.add("warning");
                }
            }

            if (!privacyPolicy.checked) {
                const privacyParent = privacyPolicy.closest(".confirm_accept");
                if (privacyParent) {
                    privacyParent.classList.add("warning");
                }
            }
            showTooltip(checkoutButton, "Proszę zaakceptować warunki");
            return false;
        }
        window.location.href = '/checkout';
        return true;
    });
}

function resetValidationFlags() {
    const checkoutButton = document.querySelector(".quick-cart__submit");
    const regulationAccept = document.querySelector("#regulation_accept");
    const privacyPolicy = document.querySelector("#privacy_policy");
    
    if (checkoutButton) {
        checkoutButton.dataset.validationInitialized = 'false';
    }
    if (regulationAccept) {
        regulationAccept.dataset.listenerAdded = 'false';
    }
    if (privacyPolicy) {
        privacyPolicy.dataset.listenerAdded = 'false';
    }
}

document.addEventListener("DOMContentLoaded", () => {
    initQuickCartValidation();
    initMainCartValidation();
});

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes);
            const removedNodes = Array.from(mutation.removedNodes);
            
            const hasQuickCartChange = addedNodes.some(node => 
                node.nodeType === 1 && 
                (node.classList?.contains('quick-cart') || 
                 node.querySelector?.('.quick-cart') ||
                 node.classList?.contains('quick-cart__form') ||
                 node.querySelector?.('.quick-cart__form'))
            ) || removedNodes.some(node => 
                node.nodeType === 1 && 
                (node.classList?.contains('quick-cart') || 
                 node.querySelector?.('.quick-cart') ||
                 node.classList?.contains('quick-cart__form') ||
                 node.querySelector?.('.quick-cart__form'))
            );
            
            if (hasQuickCartChange) {
                setTimeout(() => {
                    resetValidationFlags();
                    initQuickCartValidation();
                    console.log("Quick cart validation re-initialized");
                }, 200);
            }
        }
    });
});

document.addEventListener('cart:updated', () => {
    setTimeout(() => {
        resetValidationFlags();
        initQuickCartValidation();
    }, 300);
});

document.addEventListener('quick-cart:open', () => {
    setTimeout(() => {
        resetValidationFlags();
        initQuickCartValidation();
        console.log("Quick cart opened - re-initializing validation");
    }, 100);
});

document.addEventListener('drawer:opened', () => {
    setTimeout(() => {
        resetValidationFlags();
        initQuickCartValidation();
        console.log("Drawer opened - re-initializing validation");
    }, 100);
});

setInterval(() => {
    const checkoutButton = document.querySelector(".quick-cart__submit");
    if (checkoutButton && checkoutButton.dataset.validationInitialized !== 'true') {
        const regulationAccept = document.querySelector("#regulation_accept");
        const privacyPolicy = document.querySelector("#privacy_policy");
        if (regulationAccept && privacyPolicy) {
            initQuickCartValidation();
            console.log("Periodic check - re-initializing validation");
        }
    }
}, 2000);

if (document.body) {
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}
    